import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { signOut } from '../utils/auth';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLogOut, FiUser, FiSettings } = FiIcons;

const Header = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm border-b-2 border-[var(--color-border)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/portal" className="flex items-center space-x-3">
            <img 
              src="https://meinerfahrungsbericht.de/logo-me/me-logo.png" 
              alt="meLogin Logo" 
              className="h-10"
            />
          </Link>

          {user && (
            <div className="flex items-center space-x-4">
              <span className="text-sm text-[var(--color-text-light)] hidden sm:block">
                {user.email}
              </span>
              
              {isAdmin && (
                <Link
                  to="/admin"
                  className="flex items-center space-x-2 px-4 py-2 rounded-lg text-[var(--color-secondary)] hover:bg-[var(--color-light)] transition-colors"
                >
                  <SafeIcon icon={FiSettings} className="text-lg" />
                  <span className="hidden sm:inline">Admin</span>
                </Link>
              )}

              <Link
                to="/portal"
                className="flex items-center space-x-2 px-4 py-2 rounded-lg text-[var(--color-secondary)] hover:bg-[var(--color-light)] transition-colors"
              >
                <SafeIcon icon={FiUser} className="text-lg" />
                <span className="hidden sm:inline">Portal</span>
              </Link>

              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 rounded-lg text-[var(--color-error)] hover:bg-red-50 transition-colors"
              >
                <SafeIcon icon={FiLogOut} className="text-lg" />
                <span className="hidden sm:inline">Abmelden</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;